import MetricSettings from './Metric';
export default MetricSettings;